import { render, staticRenderFns } from "./enquiry.vue?vue&type=template&id=fd97f33a&scoped=true"
import script from "./enquiry.vue?vue&type=script&lang=js"
export * from "./enquiry.vue?vue&type=script&lang=js"
import style0 from "./enquiry.vue?vue&type=style&index=0&id=fd97f33a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd97f33a",
  null
  
)

export default component.exports